let nodeIdSeed = 0;
export default class Node {
  constructor(options) {
    this.nodekey = nodeIdSeed++;
    this.checked = false;
    this.data = options;
    for (let name in options) {
      if (options.hasOwnProperty(name)) {
        this[name] = options[name];
      }
    }
  }
  setChecked(status) {
    this.checked = status === true;
  }
}

